(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxKioskId(
    $http, toastr, $filter, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=resource',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/softwareDistribution/kioskID/kioskID.template.html',
      link: function(scope) {

        scope.key = {
          name: '',
          accept: false
        };
        scope.hideUI_elements = false;
        scope.secret = null;

        scope.createKioskID = function () {
          scope.hideUI_elements = true;
          var url = scope.tenant.info._links['px:kioskCredentials'].href;

          $timeout(function () {
            $http.post(url, scope.key.name).then(function(response) {
              toastr.success($filter('translate')('KioskKeyCreated'))
              scope.secret = response.data.clientSecret;
            }).catch(function(error){
              toastr.error($filter('translate')('ERROR'))
              scope.callback();
            });
          }, 1)
        }
        
        scope.copySecret = function () {
          var input = document.createElement('input');
          input.setAttribute('value', scope.secret);
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input)
          toastr.success($filter("translate")("CopyToClipboard"));
        }

      }
    };
  }

  pxKioskId.$inject = ['$http', 'toastr', '$filter', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxKioskId', pxKioskId);

})();
